module.exports = __webpack_public_path__ + "img/icon_hyt_success@2x.30144e80.png";